module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-queen.5c53d8e6.svg";